import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SecondaryNavbar from "../HomePage/Navbar/SecondaryNavbar";

import { useLanguage } from "../../context/LanguageContext";
import dataEn from "../../languages/en/register.json";
import dataTh from "../../languages/th/register.json";

const RegisterPage = () => {
  const { selectedLanguage } = useLanguage(); // Use the context
  const data = selectedLanguage === "en" ? dataEn : dataTh;

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [productType, setProductType] = useState("");
  const [numPieces, setNumPieces] = useState(0);
  const [captcha, setCaptcha] = useState("");
  const [isNameValid, setNameValid] = useState(true);
  const [isEmailValid, setEmailValid] = useState(true);
  const [isPasswordValid, setPasswordValid] = useState(true);
  const [isConfirmPasswordValid, setConfirmPasswordValid] = useState(true);
  const [isProductTypeValid, setProductTypeValid] = useState(true);
  const [isNumPiecesValid, setNumPiecesValid] = useState(true);
  const [isCaptchaValid, setCaptchaValid] = useState(true);
  const [isAgreed, setIsAgreed] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    // Simple email validation regex
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isEmailValid = emailPattern.test(email);

    // Simple password validation
    const isPasswordValid =
      password.length >= 8 &&
      /\d/.test(password) &&
      /[a-zA-Z]/.test(password) &&
      /[!@#$%^&*()_+[\]{};':"\\|,.<>?]/.test(password);

    // Simple confirm password validation
    const isConfirmPasswordValid = confirmPassword === password;

    // Simple product type validation
    const isProductTypeValid = productType !== "";

    // Simple number of pieces validation
    const isNumPiecesValid = /^\d+$/.test(numPieces);

    // Simple captcha validation
    const isCaptchaValid = captcha === "27";

    // Update the state variables for each field validation
    setEmailValid(isEmailValid);
    setPasswordValid(isPasswordValid);
    setConfirmPasswordValid(isConfirmPasswordValid);
    setProductTypeValid(isProductTypeValid);
    setNumPiecesValid(isNumPiecesValid);
    setCaptchaValid(isCaptchaValid);

    // Check if all fields are valid before submitting the form
    if (
      isEmailValid &&
      isPasswordValid &&
      isConfirmPasswordValid &&
      isProductTypeValid &&
      isNumPiecesValid &&
      isCaptchaValid &&
      isAgreed
    ) {
      console.log("Form submitted successfully!");
      // Handle form submission here
      navigate("/emailNotification", { state: { forgotPass: false } });
    }
  };

  return (
    <div className="relative">
      <SecondaryNavbar />
      <div className="max-w-lg mx-auto mt-8 p-4 bg-white rounded-lg">
        <h2 className="text-2xl font-bold mb-4 flex items-center justify-center">
          {data.title}
        </h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="name" className="block mb-2">
              {data.name} <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              className={`border w-full rounded-xl ${
                isNameValid ? "border-gray-400" : "border-red-500"
              } p-2`}
            />
            {!isNameValid && <p className="text-red-500">{data.validName}</p>}
          </div>
          <div>
            <label htmlFor="email" className="block mb-2">
              {data.email}
              <span className="text-red-500">*</span>
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className={`border w-full rounded-xl ${
                isEmailValid ? "border-gray-400" : "border-red-500"
              } p-2`}
            />
            {!isEmailValid && <p className="text-red-500">{data.validEmail}</p>}
          </div>
          {/* Password */}
          <div>
            <label htmlFor="password" className="block mb-2">
              {data.password} <span className="text-red-500">*</span>
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className={`border w-full rounded-xl ${
                isPasswordValid ? "border-gray-400" : "border-red-500"
              } p-2`}
            />
            {!isPasswordValid && (
              <p className="mt-2 text-sm">
                <span className=" text-red-500 font-semibold">
                  {data.validPassword[0]}
                </span>{" "}
                <br />
                {data.validPassword[1]} <br /> {data.validPassword[2]} <br />{" "}
                <span className="text-primary-900">
                  {" "}
                  {data.validPassword[3]}{" "}
                </span>{" "}
                {data.validPassword[4]} <br /> {data.validPassword[5]}{" "}
                <div className="mb-4 mt-1 flex space-x-2">
                  <div className="w-1/4 h-1 bg-gray-200"></div>
                  <div className="w-1/4 h-1 bg-gray-200"></div>
                  <div className="w-1/4 h-1 bg-gray-200"></div>
                  <div className="w-1/4 h-1 bg-gray-200"></div>
                </div>
                <span className=""> {data.validPassword[6]}</span>
              </p>
            )}
          </div>
          {/* Confirm Password */}
          <div>
            <label htmlFor="confirmPassword" className="block mb-2">
              {data.confirmPassword} <span className="text-red-500">*</span>
            </label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              className={`border w-full rounded-xl ${
                isConfirmPasswordValid ? "border-gray-400" : "border-red-500"
              } p-2`}
            />
            {!isConfirmPasswordValid && (
              <>
                <p className="text-red-500">{data.validConfirmPassword[0]}</p>
                <p className="mt-2 text-sm">
                  <span className=" text-red-500 font-semibold">
                    {data.validConfirmPassword[1]}
                  </span>{" "}
                  <br />
                  {data.validConfirmPassword[2]} <br />{" "}
                  {data.validConfirmPassword[3]} <br />{" "}
                  <span className="text-primary-900">
                    {" "}
                    {data.validConfirmPassword[4]}{" "}
                  </span>{" "}
                  {data.validConfirmPassword[5]} <br />{" "}
                  {data.validConfirmPassword[6]}{" "}
                  <div className="mb-4 mt-1 flex space-x-2">
                    <div className="w-1/4 h-1 bg-gray-200"></div>
                    <div className="w-1/4 h-1 bg-gray-200"></div>
                    <div className="w-1/4 h-1 bg-gray-200"></div>
                    <div className="w-1/4 h-1 bg-gray-200"></div>
                  </div>
                  <span className=""> {data.validConfirmPassword[7]}</span>
                </p>
              </>
            )}
          </div>
          {/* Type of product sold */}
          <div>
            <label htmlFor="productType" className="block mb-2">
              {data.productType}
              <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              id="productType"
              value={productType}
              onChange={(e) => setProductType(e.target.value)}
              required
              className={`border w-full rounded-xl ${
                isProductTypeValid ? "border-gray-400" : "border-red-500"
              } p-2`}
            />
            {!isProductTypeValid && (
              <p className="text-red-500">{data.validProductType}</p>
            )}
          </div>
          {/* Number of pieces delivered per day */}
          <div>
            <label htmlFor="numPieces" className="block mb-2">
              {data.numPieces}
              <span className="text-red-500">*</span>
            </label>
            <input
              type="number"
              id="numPieces"
              value={numPieces}
              min={0}
              onChange={(e) => setNumPieces(e.target.value)}
              required
              className={`border w-full rounded-xl  text-gray-600
             ${isNumPiecesValid ? "border-gray-400" : "border-red-500"} p-2`}
            />
            {!isNumPiecesValid && (
              <p className="text-red-500"> {data.validNumPieces}</p>
            )}
          </div>

          {/* Captcha */}
          <div className="flex items-center justify-between">
            <label htmlFor="captcha"> {data.captcha} </label>
            <input
              type="number"
              id="captcha"
              value={captcha}
              onChange={(e) => setCaptcha(e.target.value)}
              required
              className={`border w-3/4 rounded-xl ${
                isCaptchaValid ? "border-gray-400" : "border-red-500"
              } p-2`}
            />
            {!isCaptchaValid && (
              <p className="text-red-500"> {data.validCaptcha}</p>
            )}
          </div>
          <div className="flex items-center">
            <input
              type="checkbox"
              id="termsAndConditions"
              checked={isAgreed}
              onChange={() => setIsAgreed(!isAgreed)}
              className="h-4 w-4 text-blue-500 border-gray-300 rounded"
            />
            <label
              htmlFor="termsAndConditions"
              className="ml-2 block text-xs text-gray-900"
            >
              {data.agree}
              <a
                className="font-bold border-b-2 mx-1 cursor-pointer"
                onClick={(e) => {
                  navigate("/termsAndConditions");
                }}
              >
                {data.terms}
              </a>
              {data.and}
              <a
                className="font-bold border-b-2 ml-1 cursor-pointer"
                onClick={(e) => {
                  navigate("/policy");
                }}
              >
                {data.policy}
              </a>
              .
            </label>
          </div>
          <button
            type="submit"
            disabled={!isAgreed}
            className={`w-full bg-gradient-to-r from-primary-900 to-primary-600 text-white py-2 rounded-full font-bold hover:bg-blue-600
            ${isAgreed ? "" : "opacity-10 cursor-not-allowed"}
          `}
          >
            {data.submit}
          </button>
        </form>
        <div className=" flex justify-center text-sm my-5">
          <span className="px-2 font-medium">OR</span>
        </div>

        <div>
          <a
            href="#"
            className="font-medium text-black text-sm flex items-center justify-center space-x-2 bg-white p-2 border  rounded-3xl shadow-lg"
          >
            <img
              src={process.env.PUBLIC_URL + "/about us/register/fb.png"}
              width="20"
              height="20"
              className="mr-5"
            />
            Sign up with Facebook
          </a>
        </div>

        <div className="text-sm">
          <p className="mt-8 text-center text-gray-600">
            {data.haveAccount}
            <a
              className="font-semibold text-primary-900 cursor-pointer"
              onClick={(e) => {
                navigate("/login");
              }}
            >
              {data.login}
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
